import { render, staticRenderFns } from "./ViewRawMaterialPriceRequestPopUp.vue?vue&type=template&id=126bbfe0&scoped=true"
import script from "./ViewRawMaterialPriceRequestPopUp.vue?vue&type=script&lang=js"
export * from "./ViewRawMaterialPriceRequestPopUp.vue?vue&type=script&lang=js"
import style0 from "./ViewRawMaterialPriceRequestPopUp.vue?vue&type=style&index=0&id=126bbfe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126bbfe0",
  null
  
)

export default component.exports